import React from "react";
import Navbar from "./Navbar";

export default function Pricing() {
  return (
    <>
      <Navbar />
      
      <section className="hero">
        <div className="container">
          <div className="section-header">
            <h1>Fiyatlandırma</h1>
            <p>Kullanım temelli şeffaf fiyatlandırma</p>
          </div>
        </div>
      </section>
      
      <section>
        <div className="container">
          <div className="pricing-intro">
            <p>TercumanApp, ihtiyaçlarınıza uygun ölçeklenebilir bir fiyatlandırma modeli sunar. Ücretlendirmemiz, kullandığınız dil çiftleri ve toplam süre üzerinden hesaplanır.</p>
          </div>
          
          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>Metin Çevirisi</h3>
                <div className="pricing-price">
                  <span className="currency">₺</span>
                  <span className="amount">1,000</span>
                  <span className="period">/saat/dil çifti</span>
                </div>
                <p>Konuşma tanıma ve metin çevirisi</p>
              </div>
              <div className="pricing-features">
                <ul>
                  <li>Gerçek zamanlı konuşma tanıma</li>
                  <li>Anında metin çevirisi</li>
                  <li>Kaynak dil otomatik algılama</li>
                  <li>50+ dil desteği</li>
                  <li>Sınırsız katılımcı</li>
                  <li>Seçtiğiniz dil çifti kadar ödeme</li>
                </ul>
              </div>
              <div className="pricing-action">
                <a href="#demo" className="cta primary">Demo Talep Et</a>
              </div>
            </div>
            
            <div className="pricing-card featured">
              <div className="pricing-badge">Popüler</div>
              <div className="pricing-header">
                <h3>Ses Çevirisi</h3>
                <div className="pricing-price">
                  <span className="currency">₺</span>
                  <span className="amount">5,000</span>
                  <span className="period">/saat/dil çifti</span>
                </div>
                <p>Konuşmadan konuşmaya çeviri</p>
              </div>
              <div className="pricing-features">
                <ul>
                  <li>Metin çevirisinin tüm özellikleri</li>
                  <li>Gerçek zamanlı ses sentezi</li>
                  <li>Doğal ses seslendirmesi</li>
                  <li>Cinsiyet ve ton ayarları</li>
                  <li>25+ dilde ses desteği</li>
                  <li>Yüksek kaliteli neural ses</li>
                </ul>
              </div>
              <div className="pricing-action">
                <a href="#demo" className="cta primary">Demo Talep Et</a>
              </div>
            </div>
            
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>Kurumsal</h3>
                <div className="pricing-price">
                  <span className="contact">Bizimle İletişime Geçin</span>
                </div>
                <p>Özel ihtiyaçlar ve büyük etkinlikler için</p>
              </div>
              <div className="pricing-features">
                <ul>
                  <li>Hacim bazlı indirimler</li>
                  <li>Özel API entegrasyonu</li>
                  <li>Kişiselleştirilmiş terimce</li>
                  <li>Özel eğitilmiş model</li>
                  <li>SLA garantisi</li>
                  <li>Ayrılmış hesap yöneticisi</li>
                </ul>
              </div>
              <div className="pricing-action">
                <a href="#contact" className="cta secondary">İletişime Geç</a>
              </div>
            </div>
          </div>
          
          <div className="pricing-calculator">
            <div className="section-header">
              <h2>Fiyat Hesaplayıcı</h2>
              <p>Etkinliğiniz için tahmini maliyet</p>
            </div>
            
            <div className="calculator-example">
              <h3>Örnek Senaryolar:</h3>
              
              <div className="calculator-scenario">
                <div className="scenario-details">
                  <h4>Küçük İş Toplantısı</h4>
                  <ul>
                    <li>2 saat süre</li>
                    <li>2 dil çifti (Türkçe-İngilizce, Türkçe-Almanca)</li>
                    <li>Metin çevirisi</li>
                  </ul>
                </div>
                <div className="scenario-price">
                  <p className="price">₺4,000</p>
                  <p className="calculation">2 saat × 2 dil çifti × ₺1,000</p>
                </div>
              </div>
              
              <div className="calculator-scenario">
                <div className="scenario-details">
                  <h4>Uluslararası Konferans</h4>
                  <ul>
                    <li>6 saat süre</li>
                    <li>3 dil çifti (İngilizce-Türkçe, İngilizce-Fransızca, İngilizce-İspanyolca)</li>
                    <li>Ses çevirisi</li>
                  </ul>
                </div>
                <div className="scenario-price">
                  <p className="price">₺90,000</p>
                  <p className="calculation">6 saat × 3 dil çifti × ₺5,000</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="pricing-faq">
            <div className="section-header">
              <h2>Sıkça Sorulan Sorular</h2>
              <p>Fiyatlandırmamızla ilgili sorularınıza yanıtlar</p>
            </div>
            
            <div className="faq-grid">
              <div className="faq-item">
                <h3>Bir "dil çifti" nedir?</h3>
                <p>Bir dil çifti, bir kaynak dilden bir hedef dile çeviriyi ifade eder. Örneğin, İngilizce-Türkçe bir dil çiftidir.</p>
              </div>
              
              <div className="faq-item">
                <h3>Nasıl faturalandırılırım?</h3>
                <p>Etkinliğiniz için ödeme önceden yapılır. Kullanım süresi ve etkinlikte kullanılan dil çiftleri baz alınarak hesaplanır.</p>
              </div>
              
              <div className="faq-item">
                <h3>Kullanılmayan süre için iade alabilir miyim?</h3>
                <p>Evet, kullanılmayan süre için orantılı iade yapılır. İade talepleriniz etkinliğin sona ermesinden sonraki 7 gün içinde değerlendirilir.</p>
              </div>
              
              <div className="faq-item">
                <h3>Kaynak dil otomatik algılama ne demektir?</h3>
                <p>Sistem konuşmacının dilini otomatik olarak tespit eder ve çeviriyi buna göre yapar. Bu sayede birden fazla dilde konuşan konuşmacılar için manuel geçiş gerekmez.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="cta-section">
        <div className="container">
          <h2>İhtiyaçlarınızı Görüşelim</h2>
          <p>Etkinliğinize özel fiyatlandırma için bizimle iletişime geçin.</p>
          <div className="cta-buttons">
            <a href="#contact" className="cta primary">İletişime Geç</a>
            <a href="#demo" className="cta secondary">Demo Talep Et</a>
          </div>
        </div>
      </section>
    </>
  );
}
